<template>
    <q-bar class="bg-white">
        <q-btn dense flat round :to="{ name: 'AccountIndex' }">
            <i class="fas fa-chevron-left"></i>
        </q-btn>
        <div class="col text-center">{{ $t('account.personalInfo') }}</div>
    </q-bar>
    <q-list>
        <q-item>
            <q-item-section>
                <q-item-label>{{ $t('personalInfo.firstName') }}</q-item-label>
            </q-item-section>

            <q-item-section>
                <q-item-label>{{ personalInfo.name }}</q-item-label>
            </q-item-section>
        </q-item>

        <q-separator inset />

        <q-item>
            <q-item-section>
                <q-item-label>{{ $t('personalInfo.email') }}</q-item-label>
            </q-item-section>

            <q-item-section>
                <q-item-label>{{ personalInfo.eMail }}</q-item-label>
            </q-item-section>
        </q-item>

        <q-separator inset />

        <q-item>
            <q-item-section>
                <q-item-label>{{ $t('personalInfo.phone') }}</q-item-label>
            </q-item-section>

            <q-item-section>
                <q-item-label>{{ personalInfo.pmsPhone }}</q-item-label>
            </q-item-section>
        </q-item>

        <q-separator inset />
    </q-list>

    <div class="q-gutter-md q-ma-md">
        <q-btn class="full-width"
               outline
               :label="$t('account.editPersonalInfo')"
               :to="{ name: 'AccountEditPersonalInfo' }" />
        <q-btn class="full-width"
               outline
               :label="$t('account.changePassword')"
               :to="{ name: 'AccountChangePassword' }" />
        <q-btn class="full-width"
               color="primary"
               :label="$t('account.logout')"
               @click="onLogout"
               v-if="showLogout" />
    </div>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';

    export default {
        data() {
            return {
                isMobile: false,
            };
        },
        computed: {
            ...mapState({
                personalInfo: (state) => state.user.personalInfo,
            }),
            showLogout() {
                if (this.isMobile == true) {
                    return false;
                }

                return true;
            },
        },
        created() {
            this.detectDeviceType();
        },
        methods: {
            ...mapMutations({
                logout: 'user/LOGOUT',
            }),
            onLogout() {
                this.logout();
                this.$router.push({ name: 'Login' });
            },
            detectDeviceType() {
                this.isMobile = this.$sharedMethod();
            },
        },
    };
</script>
